import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import UserDropdown from "src/@core/layouts/components/shared-components/UserDropdown";

const AppBarContent = (props) => {
  const { hidden, settings, toggleNavVisibility } = props;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minHeight: 56,
      }}
    >
      <Box
        className="actions-left"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          minWidth: 0,
          flex: 1,
        }}
      >
        {hidden ? (
          <IconButton
            color="inherit"
            aria-label="Open navigation menu"
            onClick={toggleNavVisibility}
            sx={{
              ml: -0.5,
              border: 1,
              borderColor: "divider",
              borderRadius: 1.5,
              bgcolor: "background.paper",
            }}
          >
            <MenuIcon />
          </IconButton>
        ) : null}
        <Box sx={{ minWidth: 0, display: { xs: hidden ? "none" : "block", sm: "block" } }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, color: "text.primary", lineHeight: 1.3 }}
            noWrap
          >
            Veeransh Control Center
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            Chemical ERP &amp; SEO operations
          </Typography>
        </Box>
      </Box>
      <Box className="actions-right" sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
        <UserDropdown settings={settings} />
      </Box>
    </Box>
  );
};

export default AppBarContent;
